import type { GroupMeetingPrepBrief, MeetingPrepBrief } from 'types/meetingPrep';

/** Distinguishes the group brief from the single-client brief for sections shared between both. */
export function isGroupBrief(brief: MeetingPrepBrief | GroupMeetingPrepBrief): brief is GroupMeetingPrepBrief {
    return 'groupName' in brief;
}
